import DateRangePicker from "./DateRangePicker";
import MobileDateRangePicker from "./MobileDateRangePicker";

export { DateRangePicker, MobileDateRangePicker };

export default DateRangePicker;
